import React from 'react';
import Box from '@mui/material/Box';

const Root = ({ children }: { children: React.ReactNode }) => {
  return <Box sx={{ height: '100vh' }}>{children}</Box>;
};

export default Root;
